import { storageService } from '..';

interface IData {
  accepted?: string[];
  denied?: string[];
  userId: string;
  id: string;
}

const VARIABLES = {
  keyRecentVerifications: 'recentVerifications'
};

const recentVerifications = {
  get: () => storageService.getValue<IData[]>(VARIABLES.keyRecentVerifications, [])!,
  remove: () => localStorage.removeItem(VARIABLES.keyRecentVerifications),
  add: (verificationIds: IData[]) => {

    if (!verificationIds || verificationIds.length === 0) {
      return;
    }

    const values = [
      ...storageService.recentVerifications.get(),
      ...verificationIds
    ];

    storageService.setValue(VARIABLES.keyRecentVerifications, values);
  },
  keepOnlyFirst: (count = 10) => {
    const newVerificationIds = [...recentVerifications.get()].splice(0, count);
    storageService.setValue(VARIABLES.keyRecentVerifications, newVerificationIds);
  }
};

export default recentVerifications;
